export default "__VITE_ASSET__PqSzG9QN__"